<template>
  <div
    class="grid h-[calc(100vh-var(--headerHeight))] overflow-hidden transition-all duration-300"
    :class="{
      'lg:grid-cols-(--feedColsClosed)': !layoutStore.feedDetailIsOpen,
      'lg:grid-cols-(--feedColsOpened)': layoutStore.feedDetailIsOpen,
    }">
    <aside
      ref="sidebar"
      data-testid="sidebar"
      class="dpaNewsFeedLayout__sidebar hidden h-[calc(100vh-var(--headerHeight))] overflow-y-auto bg-white lg:block">
      <slot name="aside"></slot>
    </aside>
    <main
      ref="main"
      class="dpaNewsFeedLayout__main h-calc(100vh-var(--headerHeight)) overflow-y-auto">
      <slot name="banner" />
      <div class="py-4">
        <slot />
      </div>
    </main>

    <aside
      ref="dynamicContent"
      data-testid="sidebarLayoutDynamicContent"
      class="h-calc(100vh-var(--headerHeight)) relative hidden overflow-x-hidden overflow-y-auto bg-surface-level-1 lg:block">
      <slot name="dynamicContent" />
    </aside>
  </div>
</template>

<script setup lang="ts">
import { useTemplateRef, watchEffect } from "vue";

import { useLayoutStore } from "@/stores/layout.ts";
import useSidebarLayoutStore from "@/stores/sidebarLayoutStore.ts";

const layoutStore = useLayoutStore();
const dynamicContent = useTemplateRef("dynamicContent");
const mainRef = useTemplateRef("main");
const sidebarRef = useTemplateRef("sidebar");

const sidebarLayoutStore = useSidebarLayoutStore();

watchEffect(() => {
  if (mainRef.value) {
    sidebarLayoutStore.setMainRef(mainRef.value);
  }
  if (dynamicContent.value) {
    sidebarLayoutStore.setDynamicContentRef(dynamicContent.value);
  }
  if (sidebarRef.value) {
    sidebarLayoutStore.setSidebarRef(sidebarRef.value);
  }
});
</script>
<style>
.dpaNewsFeedLayout {
  display: grid;
  grid-template-columns: 248px 1fr;
}
</style>
